import {
  CA_SAVE_CA_BEGIN,
  CA_SAVE_CA_SUCCESS,
  CA_SAVE_CA_FAILURE,
  CA_SAVE_CA_DISMISS_ERROR,
} from './constants';




import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';
import {CREATE_PROJECT_MODEL_ACTION_CREATE} from '../../common/redux/constantes';


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveCa(ca, action,args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CA_SAVE_CA_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let URL = SERVER_PATH + '/control_accounts';
      if(action === CREATE_PROJECT_MODEL_ACTION_CREATE){
        ca.ca = 0;
        URL+="/create";
      }else{
        URL+="/edit";
      }


      axios.post(URL, {
        control_account:ca
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          if(res.data.success === 1)
          {
            dispatch({
              type: CA_SAVE_CA_SUCCESS,
              data: res,
              action_model:action
            });
            resolve(res);
          }else{
          dispatch({
            type: CA_SAVE_CA_FAILURE,
            data: { error: "Internal error" },
            action_model:action
          });
          reject("Internal error!");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CA_SAVE_CA_FAILURE,
            data: { error: err },
            action_model:action
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveCaError() {
  return {
    type: CA_SAVE_CA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CA_SAVE_CA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveCaPending: true,
        saveCaError: null,
      };

    case CA_SAVE_CA_SUCCESS:
      // The request is success
      let fragmentContent = "The Control Account has been updated with success!";
      let fragmentTitle = "Update Control Account";
      let paperTitle = "Update Control Account";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE)
      {
        fragmentContent='The control account has been created with success!'
        fragmentTitle='Create Control Account'
        paperTitle='Create Control Account'
      }
      return {
        ...state,
        saveCaPending: false,
        saveCaError: null,
        fragmentContent:fragmentContent,
        fragmentTitle:fragmentTitle,
        paperTitle:paperTitle,
      };

    case CA_SAVE_CA_FAILURE:
      // The request is failed
      let fragmentContentFail = "We found an error";
      let fragmentTitleFail = "Update Control Account";
      let paperTitleFail = "Update Control Account";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE){

        fragmentContentFail='The control account has not been created with success!'
        fragmentTitleFail='Create Control Account'
        paperTitleFail='Create Control Account'
      }
      return {
        ...state,
        saveCaPending: false,
        saveCaError: action.data.error,
        fragmentContent:fragmentContentFail,
        fragmentTitle:fragmentTitleFail,
        paperTitle:paperTitleFail,
      };

    case CA_SAVE_CA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveCaError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/ca/redux/saveCa.js